export default __webpack_public_path__ + "static/media/0000..0007.04948038.png";